import React, { useContext, useMemo } from 'react';
import { useRequest } from 'ahooks';
import {
  apiV2GasMonitorMapSevenDaysAlertPost,
  V2GasMonitorMapSevenDaysAlertPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { GasMonitorContext } from '../../../context';
import styles from './index.module.scss';
import { Spin } from 'antd';
import highestImg from '../../../../../imgs/highest.png';
import highImg from '../../../../../imgs/high.png';
import middleImg from '../../../../../imgs/middle.png';
import lowImg from '../../../../../imgs/low.png';
import lowestImg from '../../../../../imgs/lowest.png';
import dayjs from 'dayjs';
import { AlarmLevel } from '@/shared/types';

interface AlarmLevelConfig {
  label: string;
  img: string;
  countKey: keyof V2GasMonitorMapSevenDaysAlertPostResponse;
  color: string;
  state: AlarmLevel;
}

const ALARM_LEVEL_CONFIG: AlarmLevelConfig[] = [
  { label: '最高级', img: highestImg, countKey: 'highestLevelCount', color: '#FF4D4F', state: AlarmLevel.HIGHEST },
  { label: '高级', img: highImg, countKey: 'highLevelCount', color: '#FF9247', state: AlarmLevel.HIGH },
  { label: '中级', img: middleImg, countKey: 'mediumLevelCount', color: '#00ADFF', state: AlarmLevel.MIDDLE },
  { label: '低级', img: lowImg, countKey: 'lowLevelCount', color: '#59D744', state: AlarmLevel.LOW },
  { label: '最低级', img: lowestImg, countKey: 'lowestLevelCount', color: '#ABD335', state: AlarmLevel.LOWEST },
];

const AlarmStats: React.FC = () => {
  const { configDetail } = useContext(GasMonitorContext);

  const { data, loading } = useRequest(
    () =>
      apiV2GasMonitorMapSevenDaysAlertPost({
        labelIds: configDetail?.labelIds ?? [],
      }),
    {
      ready: !!configDetail,
    }
  );

  return (
    <Spin spinning={loading}>
      <div className={styles.alarmContainer}>
        {/* Top row: 最高级, 高级, 中级 */}
        <div className={styles.alarmTopRow}>
          {ALARM_LEVEL_CONFIG.slice(0, 3).map(config => (
            <div
              key={config.label}
              className={styles.alarmItem}
              onClick={() =>
                window.open(
                  `/device/alarm/record?startTime=${dayjs()
                    .subtract(6, 'day')
                    .startOf('day')
                    .valueOf()}&endTime=${dayjs().endOf('day').valueOf()}&labelIds=${configDetail?.labelIds}&state=${
                    config.state
                  }`,
                  '_blank'
                )
              }
            >
              <img src={config.img} alt={config.label} className={styles.alarmPedestal} />
              <span className={styles.alarmNumber} style={{ color: config.color }}>
                {data?.[config.countKey] ?? 0}
              </span>
              <span className={styles.alarmLabel}>{config.label}</span>
            </div>
          ))}
        </div>
        {/* Bottom row: 低级, 最低级 */}
        <div className={styles.alarmBottomRow}>
          {ALARM_LEVEL_CONFIG.slice(3).map(config => (
            <div
              key={config.label}
              className={styles.alarmItem}
              onClick={() =>
                window.open(
                  `/device/alarm/record?startTime=${dayjs()
                    .subtract(6, 'day')
                    .startOf('day')
                    .valueOf()}&endTime=${dayjs().endOf('day').valueOf()}&labelIds=${configDetail?.labelIds}&state=${
                    config.state
                  }`,
                  '_blank'
                )
              }
            >
              <img src={config.img} alt={config.label} className={styles.alarmPedestal} />
              <span className={styles.alarmNumber} style={{ color: config.color }}>
                {data?.[config.countKey] ?? 0}
              </span>
              <span className={styles.alarmLabel}>{config.label}</span>
            </div>
          ))}
        </div>
      </div>
    </Spin>
  );
};

export default AlarmStats;
